import { Injectable } from '@angular/core'
import { isNullOrUndefined } from '@gofive/angular-common'
import { map } from 'rxjs'
import { DataTableModel } from 'src/domain/models/datatable.model'
import { ProductTypeModel } from 'src/domain/models/product.model'
import { ProductRepository } from 'src/domain/repositories/product.repository'
import { DefaultResultData, DefaultResultDataSource } from '../entities/base.entity'
import {
	ProductActiveTypeEntity,
	ProductDataTableTypeEntity,
	ProductItemTypeEntity,
	ProductTypeEntity,
} from '../entities/product.entity'
import { ProductActiveMapper } from '../mappers/product/product-active.mapper'
import { ProductDataTableMapper } from '../mappers/product/product-data-table.mapper'
import { ProductItemMapper } from '../mappers/product/product-item.mapper'
import { ProductMapper } from '../mappers/product/product.mapper'

@Injectable({
	providedIn: 'root',
})
export class ProductImplementationRepository extends ProductRepository {
	productItemMapper = new ProductItemMapper()
	productDataTableMapper = new ProductDataTableMapper()
	productActiveMapper = new ProductActiveMapper()
	productMapper = new ProductMapper()

	GetProductAsync(params: { id: number }) {
		return this.get<DefaultResultData<ProductTypeEntity>>('api/Products/' + params.id).pipe(
			map((response) => {
				return this.productMapper.mapFrom(response.data)
			}),
		)
	}

	AddProduct(params: { model: ProductTypeModel }) {
		return this.post<any>('api/Products', params.model)
	}

	EditProduct(params: { model: ProductTypeModel }) {
		return this.put<any>('api/Products/' + params.model.productId, params.model)
	}

	GetProductItem(params: { id: number }) {
		return this.get<DefaultResultData<ProductItemTypeEntity[]>>('api/Products/' + params.id + '/ProductItems').pipe(
			map((response) => {
				return response.data.map((item) => {
					return this.productItemMapper.mapFrom(item)
				})
			}),
		)
	}

	GetProduct() {
		return this.get<DefaultResultData<ProductTypeEntity[]>>('api/Products/ProductPlans').pipe(
			map((response) => {
				return response.data.map((item) => {
					return this.productMapper.mapFrom(item)
				})
			}),
		)
	}

	GetProductActive() {
		return this.get<ProductActiveTypeEntity[]>('api/Products/ProductActive').pipe(
			map((response) => {
				return response.map((item) => {
					return this.productActiveMapper.mapFrom(item)
				})
			}),
		)
	}

	GetDataTableProducts(params: {
		model: DataTableModel
		preCondition: Object
		param?: Array<string>
		search?: string
		filter?: Object
	}) {
		let whereCause: string
		if (params.filter && Object.values(params.filter).filter((x) => !isNullOrUndefined(x)).length > 0) {
			whereCause = this.createWhereCause(params.preCondition, params.param, params.search, params.filter)
		} else if (!isNullOrUndefined(params.search)) {
			whereCause = this.createWhereCause(params.preCondition, params.param, params.search)
		} else {
			whereCause = this.createWhereCause(params.preCondition)
		}
		params.model.whereCause = whereCause
		if (params.model.orderBy === null) {
			params.model.orderBy = 'ProductId'
		}
		return this.post<DefaultResultDataSource<ProductDataTableTypeEntity[]>>(
			'api/Products/DataTable',
			params.model,
		).pipe(
			map((response) => {
				return response.dataSource.map((item) => {
					return this.productDataTableMapper.mapFrom(item)
				})
			}),
		)
	}
}
